//ROUTINE MUTATIONS
export const PUSH_USER_ROUTINE = "PUSH_USER_ROUTINE"
export const RESET_USER_ROUTINES = "RESET_USER_ROUTINES"
export const SET_AGENDA_ITEMS = "SET_AGENDA_ITEMS"
export const RESET_AGENDA_ITEMS = "RESET_AGENDA_ITEMS"
export const SET_IS_DONE = "SET_IS_DONE"
export const RESET_ROUTINE_COMMENTS = "RESET_ROUTINE_COMMENTS"
export const PUSH_ROUTINE_COMMENT = "PUSH_ROUTINE_COMMENT"
export const SET_ICON_LIBRARY = "SET_ICON_LIBRARY"